/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class StatsReportDataDetails {
  COMPANY_NAME: string;
  STAGE: string;
  FA: string;
  ASSIGNEE: string;
  DAY_SUBMITTED: number;
  DELAY: string;
  DATE_DUE: string;
  DAY_ENGAGED: string;
  TAGS:string;
  

  //Helpers
  COLLAPSE: boolean;


  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): StatsReportDataDetails[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new StatsReportDataDetails(j));

    return arr;
  }
}
